import { Skeleton } from '@repo/ui/skeleton';
import { cn } from '@repo/utils/cn';
import React from 'react';

type MethodSkeletonProps = {
  hideIconSkeleton?: boolean;
  className?: string;
};

const MethodSkeleton: React.FC<MethodSkeletonProps> = ({ hideIconSkeleton, className }) => (
  <div
    className={cn('flex h-[48px] w-full items-center justify-between rounded-lg px-2.5 py-3 sm:h-[58px]', className)}
  >
    {/* Icon placeholder */}
    {!hideIconSkeleton && (
      <div className="flex flex-shrink-0 items-center space-x-2.5 vt-spacing-small">
        <Skeleton className="h-8 w-8 rounded-full" />
      </div>
    )}

    {/* Text placeholders */}
    <div className="mx-2 flex flex-1 flex-col space-y-2">
      <Skeleton className="h-4 w-32 rounded" />
      <Skeleton className="h-3 w-24 rounded" />
    </div>
  </div>
);

export default MethodSkeleton;
